// import action types
import { UPDATE_MEMBER_MANAGEMENT_STATE, CLEAR_MEMBER_MANAGEMENT_STATE } from 'constants/redux-events';

/********************************************************/

/**
 * @type {function}
 * @desc A Redux Reducer to manage state of the Redux Store
 * @param {object} [state={}] - Current state of the Redux Store at given state key
 * @param {object} action - Redux **action** object with **event name** and **payload**
 * @example
 * import { memberManagementState } from 'reducers/memberManagementState';
 */
export const memberManagementState = ( state = {}, action ) => {
    const { type, payload } = action;

    switch( type ) {

        case UPDATE_MEMBER_MANAGEMENT_STATE:
            return payload;

        case CLEAR_MEMBER_MANAGEMENT_STATE:
            return {};
            
        default:
            return state;
    }
};
